var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, ButtonGroup, Input } from 'Components.Form';
import { FormattedMessage, useIntl } from 'Intl';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: .3rem;\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n"], ["\n  margin-bottom: .3rem;\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n"])));
var SearchTypeButtonGroup = styled(ButtonGroup)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: .5rem;\n  justify-content: flex-start;\n  > ", " {\n    flex: initial;\n  }\n"], ["\n  margin-bottom: .5rem;\n  justify-content: flex-start;\n  > ", " {\n    flex: initial;\n  }\n"])), Button);
var SearchButtonGroup = styled(ButtonGroup)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  gap: 0.5rem;\n"], ["\n  gap: 0.5rem;\n"])));
var SearchButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex: none!important;\n"], ["\n  flex: none!important;\n"])));
var ErrorMessageContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: red;\n  font-weight: bold;\n  font-size: 14px;\n  margin-top: 1rem;\n"], ["\n  color: red;\n  font-weight: bold;\n  font-size: 14px;\n  margin-top: 1rem;\n"])));
var SelectedVehicleContainer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-top: 1rem;\n"], ["\n  margin-top: 1rem;\n"])));
var LookupVehicle = function (_a) {
    var baseId = _a.baseId, onLookup = _a.onLookup, onVehicleFound = _a.onVehicleFound, selectedVehicle = _a.selectedVehicle;
    var _b = useState('vrn'), lookupType = _b[0], setLookupType = _b[1];
    var _c = useState(''), searchInput = _c[0], setSearchInput = _c[1];
    var _d = useState(false), isSearching = _d[0], setIsSearching = _d[1];
    var _e = useState(), errorMessage = _e[0], setErrorMessage = _e[1];
    var intl = useIntl();
    var handleSearch = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!searchInput)
                        return [2 /*return*/];
                    setIsSearching(true);
                    setErrorMessage(null);
                    return [4 /*yield*/, onLookup(lookupType, searchInput)];
                case 1:
                    result = _b.sent();
                    if (result.vehicle) {
                        onVehicleFound(result.vehicle);
                    }
                    else {
                        setErrorMessage((_a = result.error) !== null && _a !== void 0 ? _a : intl.formatMessage('lookupVehicle.genericError'));
                    }
                    setIsSearching(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Container, null,
        React.createElement(SearchTypeButtonGroup, null,
            React.createElement(Button, { id: "".concat(baseId, "_vrn_button"), onClick: function () { return setLookupType('vrn'); }, primary: lookupType === 'vrn' },
                React.createElement(FormattedMessage, { id: 'common.vrn' })),
            React.createElement(Button, { id: "".concat(baseId, "_vin_button"), onClick: function () { return setLookupType('vin'); }, primary: lookupType === 'vin' },
                React.createElement(FormattedMessage, { id: 'common.vin' }))),
        React.createElement(SearchButtonGroup, null,
            React.createElement(Input, { id: "".concat(baseId, "_search_input"), value: searchInput, onChange: function (e) { return setSearchInput(e.target.value); }, placeholder: lookupType === 'vrn'
                    ? intl.formatMessage('common.vrn')
                    : intl.formatMessage('common.vin') }),
            React.createElement(SearchButton, { id: "".concat(baseId, "_search_button"), onClick: handleSearch, disabled: isSearching || !searchInput, primary: true }, isSearching
                ? React.createElement(FormattedMessage, { id: 'lookupVehicle.searching' })
                : React.createElement(FormattedMessage, { id: 'lookupVehicle.findVehicle' }))),
        errorMessage && (React.createElement(ErrorMessageContainer, { id: "".concat(baseId, "_errorMessage") }, errorMessage)),
        selectedVehicle && (React.createElement(SelectedVehicleContainer, { id: "".concat(baseId, "_vehicleDetails") },
            React.createElement("strong", { id: "".concat(baseId, "_vehicleDetails_vrn") }, selectedVehicle.vrn),
            React.createElement("br", null),
            React.createElement("span", { id: "".concat(baseId, "_vehicleDetails_makeModel") },
                selectedVehicle.make,
                " - ",
                selectedVehicle.model)))));
};
export default LookupVehicle;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
